export const MAX_INT_VALUE = 2147483647;
